import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => ({
  hideTabPanel: {
    display: 'none'
  }
}));
